export default {
  tabs: {
    access: 'Acces',
    notification_preferences: 'Preferințe notificări',
  },
  sections: {
    notification_preferences: {
      title: 'Preferințe notificări',
      form: {
        has_voice_call_reminders: {
          label: 'Primiți apeluri automate despre comenzi în așteptare',
        },
        voice_reminders_phone_number: {
          label: 'Număr de telefon pentru apeluri',
        },
        has_whatsapp_notifications: {
          label: 'Trimiteți notificări (ex. comenzi în pauză) prin WhatsApp',
        },
        whatsapp_phone_number: {
          label: 'Număr de telefon WhatsApp',
        },
        has_order_email_notifications: {
          label: 'Trimiteți notificări despre comenzi prin email',
        },
        order_notifications_email: {
          label: 'Adresă email pentru redirecționarea notificărilor',
        },
      },
    },
    voice_calls: {
      title: 'Apeluri vocale',
    },
    whats_app_notifications: {
      title: 'Notificări WhatsApp',
    },
    order_email_notifications: {
      title: 'Notificări comenzi prin email',
    },
    access_control: {
      title: 'Control acces',
      form: {
        company_ids: {
          label: 'Poate accesa restaurante',
          tooltip: 'Oferă acces la următoarele restaurante (pe lângă restaurantele din același brand)',
        },
      },
    },
  },
  buttons: {
    save: 'Salvare',
  },
  toasts: {
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
